export default __webpack_public_path__ + "static/media/GetStartedBG.6e65641d.svg";